module.exports = __webpack_public_path__ + "img/chevron-left-green.bea67ca4.svg";